// angular
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
// types & constants
import { IPages } from '@app/shared/types/footer-menu.type';
import {
  footerPlatformPages,
  footerCompanyPages,
  footerLegalColumnPrimary,
  footerLegalColumnSecondary,
  footerSocialMedias,
} from '@app/shared/constants/footer-data.const';
import {
  COMPANY_ADDRESS_I18N_KEY,
  COMPANY_PHONE_DISPLAY,
  COMPANY_PHONE_TEL,
} from '@app/shared/constants/company-contact.const';

@Component({
  selector: 'pwj-footer',
  standalone: true,
  imports: [RouterLink, CommonModule, NgOptimizedImage, TranslateModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  public platformPages: IPages[] = footerPlatformPages;
  public companyPages: IPages[] = footerCompanyPages;
  public legalColumnPrimary: IPages[] = footerLegalColumnPrimary;
  public legalColumnSecondary: IPages[] = footerLegalColumnSecondary;
  public socialMedias = footerSocialMedias;
  public readonly companyPhoneDisplay = COMPANY_PHONE_DISPLAY;
  public readonly companyPhoneTel = COMPANY_PHONE_TEL;
  public readonly companyAddressKey = COMPANY_ADDRESS_I18N_KEY;

  public fullYear = new Date().getFullYear();
}
